import { z } from 'zod'

export const strategyValuesSchema = z.object({
  strategy_name: z.string().min(1, 'Enter a strategy name').max(100, 'Maximum 100 characters'),
  strategy_type: z.string().min(1, 'Enter a strategy type').max(100, 'Maximum 100 characters'),
  is_internal: z.enum(['true', 'false'], { error: 'Select Internal or External' }),
  active: z.enum(['true', 'false'], { error: 'Select Active or Inactive' }),
})

export type StrategyValues = z.infer<typeof strategyValuesSchema>

export const existingStrategyValuesSchema = (strategyTypes: string[]) =>
  strategyValuesSchema.extend({
    strategy_type: strategyValuesSchema.shape.strategy_type.refine(
      (value) => strategyTypes.includes(value),
      'Select an existing strategy type',
    ),
  })
